import BigNumber from 'bignumber.js';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { UseGasPriceReturnType } from 'wagmi';

import { validateCollateralAmount } from './utils/validateCollateralAmount';

type ContextType = {
    collateralAmountValidation: ReturnType<typeof validateCollateralAmount> | undefined;
    openPositionFee: {
        value: {
            base: BigNumber;
            final: BigNumber;
        };
        usd: {
            base: BigNumber;
            final: BigNumber;
        };
    } | undefined;
    openPositionGasFee: {
        gasInNativeToken: BigNumber,
        gasInUsd: BigNumber | undefined
    } | undefined;
    openLimitGasFee: {
        gasInNativeToken: BigNumber,
        gasInUsd: BigNumber | undefined
    } | undefined;
}

export const TradeModuleContext = createContext<ContextType>({
    collateralAmountValidation: undefined,
    openPositionFee: undefined,
    openPositionGasFee: {
        gasInNativeToken: BigNumber(0),
        gasInUsd: undefined,
    },
    openLimitGasFee: {
        gasInNativeToken: BigNumber(0),
        gasInUsd: undefined,
    },
});

export const useTradeModule = () => {
    return useContext(TradeModuleContext);
}